import { useIntl } from "react-intl";
import { useToast } from "../components/Ui/Toast";

export const useToastNotifications = () => {
  const { toast } = useToast();
  const intl = useIntl();

  const showSuccessToast = ({
    description = "Opération réussie",
    title = "Succès",
  }: {
    description?: string;
    title?: string;
  }) => {
    toast({
      title: intl.formatMessage({ id: title }),
      description: intl.formatMessage({ id: description }),
      severity: "success",
    });
  };

  const showErrorToast = ({
    description = "error.unknownError",
    title = "Erreur",
  }: {
    description?: string;
    title?: string;
  }) => {
    toast({
      title: intl.formatMessage({ id: title }),
      description: intl.formatMessage({ id: description }),
      severity: "error",
    });
  };

  return { showSuccessToast, showErrorToast };
};
